import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { GALLERY, GALLERY_TABS } from "@/data/content";
import { Reveal, SectionHead } from "./Reveal";

export const Gallery = () => {
  const [tab, setTab] = useState("All");
  const items = GALLERY.filter((g) => tab === "All" || g.cat === tab);
  return (
    <section id="gallery" className="py-24 lg:py-36 bg-linen" data-testid="gallery-section">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <SectionHead eyebrow="Gallery · Inspiration" title="Recent Melbourne projects." />
          <Reveal delay={0.2} className="flex flex-wrap gap-2" data-testid="gallery-tabs">
            {GALLERY_TABS.map((t) => (
              <button key={t} onClick={() => setTab(t)} data-testid={`gallery-tab-${t.toLowerCase().replace(/\s+/g, "-")}`}
                className={`h-10 px-4 text-[13px] font-medium tracking-wide border transition-colors duration-300 ${tab === t ? "bg-ink text-linen border-ink" : "border-line text-stone hover:border-ink hover:text-ink"}`}>{t}</button>
            ))}
          </Reveal>
        </div>
        <motion.div layout className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[260px] gap-4" data-testid="gallery-grid">
          <AnimatePresence mode="popLayout">
            {items.map((g) => (
              <motion.figure key={g.title} layout initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.94 }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className={`group relative overflow-hidden bg-ink ${tab === "All" ? g.span || "" : ""}`} data-testid={`gallery-item-${g.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <img src={g.img} alt={g.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
                <figcaption className="absolute bottom-0 inset-x-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="eyebrow">{g.cat}</span>
                  <p className="font-serif text-xl text-linen mt-1">{g.title}</p>
                </figcaption>
              </motion.figure>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
